
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/passwordReset/RequestPasswordReset",
      function () {
        return require("private-next-pages/passwordReset/RequestPasswordReset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/passwordReset/RequestPasswordReset"])
      });
    }
  